import { render } from "./BuscaAvancada.vue?vue&type=template&id=0493b74a&scoped=true&ts=true"
import script from "./BuscaAvancada.vue?vue&type=script&lang=ts"
export * from "./BuscaAvancada.vue?vue&type=script&lang=ts"

import "./BuscaAvancada.vue?vue&type=style&index=0&id=0493b74a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0493b74a"]])

export default __exports__